import type { Properties } from 'js-java-properties'
import { setProperty } from 'js-java-properties'

import { LEGACY_MODBUS_SERIAL_CONFIG_DEFAULTS } from '@/features/controller/configuration/models/raspiProperties/defaults'
import type { ConfigWithErrors } from '@/features/controller/configuration/models/raspiProperties/errors'
import { extractErrors } from '@/features/controller/configuration/models/raspiProperties/errors'
import type { LegacyModbusSerialConfig } from '@/features/controller/configuration/models/raspiProperties/types'
import { ModbusSerialEncoding } from '@/features/controller/configuration/models/raspiProperties/types'
import {
  readEnumProperty,
  readNumberProperty,
  readPositiveNumberProperty,
} from '@/features/controller/configuration/models/raspiProperties/utils'

const PROP_MODBUS_SERIAL_ENCODING = 'modbus.serial.encoding'
const PROP_MODBUS_SERIAL_DEVICE_NUMBER = 'modbus.serial.deviceNumber'
const PROP_MODBUS_SERIAL_TRANSMISSION_DELAY_MS = 'modbus.serial.transmissionDelayMs'

export function readLegacyModbusSerialConfig(properties: Properties): ConfigWithErrors<LegacyModbusSerialConfig> {
  const errors: string[] = []
  return {
    config: {
      // Reported on the controller row, where a bare `device number` would read as a meter's own
      deviceNumber: extractErrors(
        readPositiveNumberProperty(
          properties,
          PROP_MODBUS_SERIAL_DEVICE_NUMBER,
          'Modbus serial device number',
          LEGACY_MODBUS_SERIAL_CONFIG_DEFAULTS.deviceNumber,
        ),
        errors,
      ),
      encoding: extractErrors(
        readEnumProperty(
          properties,
          PROP_MODBUS_SERIAL_ENCODING,
          'Modbus serial encoding',
          ModbusSerialEncoding,
          LEGACY_MODBUS_SERIAL_CONFIG_DEFAULTS.encoding,
        ),
        errors,
      ),
      transmissionDelayInMilliseconds: extractErrors(
        readNumberProperty(
          properties,
          PROP_MODBUS_SERIAL_TRANSMISSION_DELAY_MS,
          'Modbus serial transmission delay',
          LEGACY_MODBUS_SERIAL_CONFIG_DEFAULTS.transmissionDelayInMilliseconds,
        ),
        errors,
      ),
    },
    errors,
  }
}

export function writeLegacyModbusSerialConfig(properties: Properties, config: LegacyModbusSerialConfig) {
  setProperty(properties, PROP_MODBUS_SERIAL_DEVICE_NUMBER, config.deviceNumber?.toString())
  setProperty(properties, PROP_MODBUS_SERIAL_ENCODING, config.encoding?.toString())
  setProperty(
    properties,
    PROP_MODBUS_SERIAL_TRANSMISSION_DELAY_MS,
    (config.transmissionDelayInMilliseconds || 0).toString(),
  )
}
